import React from 'react'
import {StyleSheet, TextProps} from 'react-native'
import Svg, {Path, PathProps, SvgProps} from 'react-native-svg'

type Props = {
  fill?: PathProps['fill']
  style?: TextProps['style']
} & Omit<SvgProps, 'style'>

export const LogoClrSky = React.forwardRef(function LogoImpl(
  props: Props,
  ref,
) {
  const {fill, ...rest} = props
  const styles = StyleSheet.flatten(props.style)
  const _fill = '#2755a6'
  // @ts-ignore it's fiiiiine
  const size = parseInt(rest.width || 180)

  return (
    <Svg
      fill="none"
      // @ts-ignore it's fiiiiine
      ref={ref}
      viewBox="0 0 391.3 71"
      {...rest}
      style={[{width: size}, styles]}>
      <Path
        fill={_fill}
        d="M3.7,21.8c1.6-4.2,3.9-7.8,6.8-11,2.9-3.1,6.4-5.5,10.4-7.3,4-1.8,8.4-2.6,13.1-2.6s5.7.4,8.4,1.1c2.7.7,5.2,1.8,7.6,3.2,2.3,1.4,4.5,3.1,6.5,5.1s3.7,4.4,5.1,7l-10.6,7.5c-2-3.7-4.4-6.4-7.2-8.2-2.8-1.8-6.1-2.7-9.7-2.7s-5.5.6-7.9,1.7c-2.3,1.1-4.3,2.6-5.9,4.6-1.6,1.9-2.8,4.2-3.7,6.8-.9,2.6-1.3,5.5-1.3,8.6s.4,5.9,1.3,8.5c.9,2.6,2.1,4.9,3.8,6.9,1.7,2,3.7,3.5,6,4.6s4.9,1.7,7.8,1.7,7.1-.9,10-2.8c3-1.9,5.5-4.5,7.5-8.1l10.1,7.6c-1.3,2.6-2.9,4.9-4.9,6.9s-4.2,3.7-6.6,5.1c-2.4,1.4-5,2.4-7.8,3.1-2.7.7-5.6,1.1-8.5,1.1-4.7,0-9.1-.9-13.1-2.6-4-1.8-7.5-4.2-10.5-7.3-2.9-3.1-5.2-6.8-6.8-11.1s-2.4-8.9-2.4-13.8.8-9.4,2.4-13.6h.1Z"
      />
      <Path
        fill={_fill}
        d="M71.4,1.9h13.7v56.6l-1.4-1.6h34.6v12.3h-46.9s0-67.3,0-67.3Z"
      />
      <Path
        fill={_fill}
        d="M138.9,14.1l1.4-1.6v56.7h-13.7V1.9h28.6c3.2,0,6.1.5,8.8,1.5s5,2.4,7,4.2,3.6,4,4.7,6.6c1.1,2.6,1.7,5.4,1.7,8.6,0,4.7-1.2,8.9-3.7,12.4-2.5,3.5-5.8,6-10,7.4l.8-2.1,15,28.7h-15.1l-13.6-26.5,2.2,1.4h-14.5v-11.9h15.1c2.9,0,5.2-.9,7-2.7,1.8-1.8,2.6-4,2.6-6.6s-.9-4.8-2.6-6.4c-1.8-1.6-4.1-2.4-7-2.4,0,0-14.7,0-14.7,0Z"
      />
      <Path
        fill={_fill}
        d="M189.2,68c-1.5-1.5-2.2-3.3-2.2-5.4s.7-4.1,2.2-5.5,3.3-2.2,5.5-2.2,4,.7,5.5,2.2,2.3,3.3,2.3,5.5-.8,4-2.3,5.4c-1.5,1.5-3.4,2.2-5.5,2.2s-4.1-.7-5.5-2.2ZM189.2,37.3c-1.4-1.5-2.1-3.3-2.1-5.4s.7-4,2.1-5.5c1.4-1.5,3.2-2.2,5.5-2.2s4,.7,5.5,2.2,2.3,3.3,2.3,5.5-.8,3.9-2.3,5.4-3.4,2.2-5.5,2.2-4.1-.7-5.5-2.2Z"
      />
      <Path
        fill={_fill}
        d="M221.9,47.8c1.7,3.3,3.9,5.8,6.5,7.5s5.8,2.5,9.4,2.5,2.7-.2,3.9-.5,2.2-.8,3.2-1.5c.9-.6,1.7-1.4,2.2-2.4.5-.9.8-1.9.8-2.9s-.3-2.2-.8-3c-.5-.9-1.3-1.6-2.3-2.3-1-.6-2.2-1.3-3.8-1.9-1.6-.6-3.3-1.3-5.4-2-2.9-1-5.7-2.1-8.3-3.2-2.6-1.1-4.9-2.4-6.9-4-2-1.5-3.6-3.4-4.7-5.6-1.2-2.2-1.7-4.9-1.7-8s.6-5.9,1.9-8.3c1.3-2.4,3-4.5,5.1-6.2,2.2-1.7,4.6-3,7.3-3.9,2.7-.9,5.5-1.3,8.4-1.3s5.5.4,7.9,1.1c2.4.7,4.6,1.7,6.5,2.8,1.9,1.2,3.6,2.6,5.1,4.3,1.5,1.7,2.7,3.5,3.7,5.5l-9.9,7.4c-1.2-2.5-3-4.6-5.3-6.2-2.3-1.7-5.1-2.5-8.2-2.5s-2.2.2-3.2.5c-1.1.3-2,.7-2.9,1.3-.8.6-1.5,1.3-2,2.2-.5.9-.8,1.9-.8,3s.4,2.6,1.1,3.5c.7.9,1.6,1.7,2.7,2.3,1.1.7,2.4,1.3,3.7,1.8,1.4.5,2.6.9,3.9,1.3,3.1,1.2,6.1,2.3,8.8,3.4,2.8,1.1,5.2,2.5,7.2,4.1s3.6,3.5,4.7,5.7,1.7,5,1.7,8.2-.7,6.1-2.1,8.6-3.2,4.5-5.4,6.1-4.8,2.9-7.6,3.7c-2.8.8-5.6,1.3-8.4,1.3s-6-.4-8.7-1.1-5.1-1.7-7.3-3-4.1-2.9-5.8-4.7c-1.7-1.9-3.1-3.9-4.2-6.1l10-7.4h0Z"
      />
      <Path
        fill={_fill}
        d="M272.4,1.9h13.7v67.3h-13.7V1.9ZM284.8,32.9l26.3-31.1h16.9l-43.2,48.6v-17.6h0ZM303.5,28l25.8,41.2h-16.1l-19.2-31.9,9.5-9.3h0Z"
      />
      <Path
        fill={_fill}
        d="M352.9,43.6L329.4,1.9h15.3l15,27.5,15-27.5h15.2l-23.5,41.7v25.6h-13.5v-25.6Z"
      />
    </Svg>
  )
})
